import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../classes/user';

@Pipe({
  name: 'usernameFilter',
  pure: false
})
export class UsernameFilterPipe implements PipeTransform {

  transform(userList: Array<User>, filterValue: string): any {
    if (!userList || !filterValue) {
      return userList;
    }
    return userList.filter(user => user.username.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1);
  }

}
